import { Grid } from "@material-ui/core";
import moment from "moment";
import AutoCompleteField from "./autocomplete";
import FromToDateField from "./from-to-date";
import { IsMobile } from "utils/is-mobile";

const STORED_DATE_FORMATS = [
  "DD/MM/YYYY",
  "DD-MM-YYYY",
  "MM-DD-YYYY",
  "YYYY-MM-DD",
];

export function parseStoredPeriodDate(value) {
  if (value == null || value === "") return null;
  const m = moment(String(value).trim(), STORED_DATE_FORMATS, true);
  return m.isValid() ? m : null;
}

const defaultOptions = [
  { value: 15, label: "Últimos 15 dias" },
  { value: 30, label: "Últimos 30 dias" },
  { value: 60, label: "Últimos 60 dias" },
  { value: 90, label: "Últimos 90 dias" },
  { value: 120, label: "Últimos 120 dias" },
  { value: 180, label: "Últimos 180 dias" },
  { value: "Outros", label: "Outros" },
];

export const DEFAULT_PERIOD_OPTION = defaultOptions[1];

export function getMomentsForPresetDayCount(dayCount) {
  const days = Number(dayCount);
  if (!Number.isFinite(days) || days < 1) {
    return { mIni: null, mFim: null };
  }
  const mFim = moment().clone().startOf("day");
  const mIni = moment()
    .clone()
    .subtract(days - 1, "days")
    .startOf("day");
  return { mIni, mFim };
}

export default function PeriodField({
  label,
  value,
  onChange,
  disabled,
  loading,
  required,
  initialDate,
  finalDate,
  setInitialDate,
  setFinalDate,
  options = defaultOptions,
  padding = false,
  datePattern = "en",
}) {
  const isMobile = IsMobile();
  const storageFormat = datePattern === "br" ? "DD-MM-YYYY" : "MM-DD-YYYY";

  const handlePeriodChange = (option) => {
    onChange(option);
    if (option && option.value !== "Outros") {
      const days = Number(option.value);
      const today = moment().format(storageFormat);
      const initial = moment()
        .subtract(days - 1, "days")
        .format(storageFormat);

      setInitialDate(initial);
      setFinalDate(today);
    } else if (option && option.value === "Outros") {
      setInitialDate("");
      setFinalDate("");
    }
  };

  return (
    <Grid
      style={{
        display: "flex",
        gap: "16px",
        paddingLeft: padding ? "8px" : "",
      }}
    >
      <Grid xs={12} md={value && value.value === "Outros" ? 4 : 12}>
        <AutoCompleteField
          options={options}
          label={label}
          value={value || DEFAULT_PERIOD_OPTION}
          onChange={handlePeriodChange}
          disabled={disabled}
          loading={loading}
          required={required}
          optionLabelKey="label"
          optionIdKey="value"
        />
      </Grid>
      <Grid xs={12} md={8} hidden={value?.value != "Outros"}>
        <FromToDateField
          label="Selecione o período"
          disabled={disabled}
          initialDate={initialDate}
          finalDate={finalDate}
          setInitialDate={setInitialDate}
          setFinalDate={setFinalDate}
          isMobile={isMobile}
          pattern={datePattern === "br" ? "br" : "en"}
        />
      </Grid>
    </Grid>
  );
}

export function getPeriodLabel({ period, initialDate, finalDate }) {
  if (period === "Outros") {
    const mi = parseStoredPeriodDate(initialDate);
    const mf = parseStoredPeriodDate(finalDate);
    const formattedInitial = mi ? mi.format("DD/MM/YYYY") : "—";
    const formattedFinal = mf ? mf.format("DD/MM/YYYY") : "—";
    return `entre ${formattedInitial} e ${formattedFinal}`;
  }
  return `dos últimos ${period} dias`;
}
